export default __webpack_public_path__ + "static/attribute1-4326b15b493637da4a39e5db2d9e1609.png";